import { isRejectedWithValue } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import i18n from "../i18n";

// Central handler for the server-side character guard (error code 7): whenever
// any API request is rejected because the backend found characters from a
// non-Latin script, show a toast naming the offending characters. This covers
// every route the guard protects — including forms that otherwise swallow the
// error — and complements the per-field hints in the filtered forms.
export const charsetErrorMiddleware = () => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const errors = action.payload?.data?.errors;

    if (Array.isArray(errors)) {
      const charsetErrors = errors.filter((e) => e?.msg?.code === 7);

      if (charsetErrors.length > 0) {
        const chars = [...new Set(charsetErrors.flatMap((e) => e?.msg?.chars ?? []))];
        const message = chars.length
          ? i18n.t("charsetError", { chars: chars.map((c) => `„${c}“`).join(", ") })
          : i18n.t("charsetErrorGeneric");
        toast.error(message);
      }
    }
  }

  return next(action);
};

export default charsetErrorMiddleware;
